// Preserve the original document envelope: email CSS, meta tags, body/HTML
// attributes and GoPhish placeholders must survive visual body edits.
export function preserveDocument(original, body) {
  if (!/<(?:html|head|body)\b|<!doctype\b/i.test(original)) return body;
  const document = new DOMParser().parseFromString(original, 'text/html');
  document.body.innerHTML = body;
  const doctype = original.match(/<!doctype[^>]*>/i)?.[0] || '<!DOCTYPE html>';
  return `${doctype}\n${document.documentElement.outerHTML}`;
}
